t = require('app/scripts/views/internal/teacup-with-helpers')('header_enterprise_license')
localizeCount = require 'app/scripts/lib/localize-count'

module.exports = t.renderable ({ enterpriseName, maxMembers, availableLicenses })->
  t.p '.u-bottom', ->
    t.format 'licenses-available', {
      enterpriseName,
      maxMembers,
      availableLicenses: localizeCount('seats', availableLicenses)
    }

    t.a '.header-banner-link-left.quiet.js-dismiss-enterprise-license-banner.u-float-right', { href: "#" }, ->
      t.icon 'close'
